import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { resetPasswordRequest } from '@/api/user';
import { navigate } from '@/slices/app';
import i18n from '@/i18n';
import { resetPassword } from '../actions';

const resetPasswordEpic: Epic = (action$) =>
  action$.pipe(
    filter(resetPassword.match),
    request(({ payload }) => resetPasswordRequest(payload), resetPassword),
  );

const resetPasswordSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(resetPassword.succeeded.match),
    mergeMap(() => [
      navigate({ to: '/auth/login' }),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('PASSWORD_RESET_SUCCESS'),
      }),
    ]),
  );

export default combineEpics(resetPasswordEpic, resetPasswordSucceededEpic);
